import './index.styl';
import _ from 'lodash';
import template from './index.jst';
import { View } from 'backbone.marionette';
import Radio from "backbone.radio";
import { Player } from '../../../../../../core/models';

export class PlayerPopup extends View {
	get template() {
		return template;
	}

	get className() {
		return 'player-popup';
	}
	initialize() {
		const {
			rounds: { scheduled_rounds }, actual_round_id, stats, has_assistant_coach
		} = this.model.attributes;

		const next_3_rounds = _.chain(scheduled_rounds).take(3).map(({ id }) => id).value();
		let current_proj_score;
		if (has_assistant_coach) {
			current_proj_score = _.get(stats, `proj_scores.${actual_round_id}`, '-');
		}
		this.model.set({
			player_model: new Player(this.model.toJSON()),
			next_3_rounds,
			current_proj_score,
		});
		$(document).find('body').css({ 'overflow': 'hidden' });
	}

	ui() {
		return {
			close: '.js-close',
			set_captain: '.js-set-captain',
			set_vice_captain: '.js-set-vice-captain',
			substitute: '.js-substitute',
			remove: '.js-remove',

			trade: '.js-trade', // Alias
			btn_trade: '.js-trade', // Alias

			favourite: '.js-favourite',
			btn_add: '.js-add-to-team',
			btn_coach: '.js-coach-locked',
			price_predictor: '.js-price-predictor'
		}
	}

	events() {
		return {
			'click @ui.close': 'close',
			'click @ui.favourite': 'onSetFavourite',
			'click @ui.remove': 'onRemove',
			'click @ui.set_captain': 'onSetCaptain',
			'click @ui.set_vice_captain': 'onSetViceCaptain',
			'click @ui.substitute': 'onSubstitute',
			'click @ui.btn_add': 'onAddPlayer',
			'click @ui.btn_coach': 'showCoachPopup',
			'click @ui.btn_trade': 'onTradePlayer',
			'input @ui.price_predictor': 'calcPrices'
		}
	}

	close() {
		$(document).find('body').css({ 'overflow': '' });
		this.destroy();
	}

	onSetCaptain() {
		this.trigger('player:set:captain', { id: this.model.get('id') });
		this.close();
	}

	onSetViceCaptain() {
		this.trigger('player:set:vice_captain', { id: this.model.get('id') });
		this.close();
	}

	onSubstitute() {
		const
			key = this.model.get('field_position_key'),
			pos = _.isNumber(key) ? key : 'bench';

		this.trigger('player:substitute', {
			pos,
			id: this.model.get('id'),
		});

		this.close();
	}

	onTradePlayer(){
		const
			key = this.model.get('field_position_key'),
			pos = _.isNumber(key) ? key : 'bench';

		this.trigger('player:trade:out', {
			pos,
			id: this.model.get('id'),
		});

		this.close();
	}

	onAddPlayer() {
		this.trigger('player:add:from:popup', { id: this.model.get('id') });

		this.close();
	}

	onSetFavourite() {
		this.ui.favourite.toggleClass('is-favourite');
		this.trigger('player:favourite', { id: this.model.get('id') });
	}

	onRemove() {
		this.trigger('player:remove', { id: this.model.get('id') });
		this.close();
	}

	showCoachPopup() {
		Radio.channel('coach').trigger('show:popup');
		this.close();
	}

	calcPrices() {
		const avg = parseInt(this.ui.price_predictor.val(), 10);
		const { player_model, next_3_rounds, actual_round_id, rounds } = this.model.attributes;
		_.each(next_3_rounds, round_id => {
			$(`.js-price-round-${round_id}`).text('?');
			$(`.js-price-change-round-${round_id}`).text('');
		});
		if (!avg) {
			return this;
		}
		const is_actual_active = rounds.has_active;

		const prices_object = player_model.getProjPricesObject(
			{ avg, next_3_rounds, is_actual_active, actual_round_id }
		);

		_.each(next_3_rounds, round_id => {
			const { price, diff } = prices_object[round_id];
			const price_curr = _.currencyFormat(price, '$', true);
			const sign = diff > 0 ? '+' : '';
			const price_diff_curr = _.currencyFormat(diff, '$', true);
			$(`.js-price-round-${round_id}`).text(price_curr);
			$(`.js-price-change-round-${round_id}`).text(sign + price_diff_curr);
		});
	}
}

export default PlayerPopup;